import { useContext, useEffect, useMemo, useRef, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";
import { dateConvert, dateHoverRange } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { callautopopulate } from "../../../services/callautopop";
import { useNavigate } from "react-router-dom";
import { DateObject } from "react-multi-date-picker";
import { useCommon } from "../../Common/useCommon";

export const useJenkisRequestList = ({ fromReport }) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const { getValuePermission } = useCommon();
    const [loader, setLoader] = useState(false);
    const tagRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [showRequestPopup, setShowRequestPopup] = useState(false)
    const [filterValues, setFilterValues] = useState({ hoveredRange: [new DateObject().subtract(8, "days"), new DateObject().add(0, "days"),] });
    const [dropDownOption, setDropDownOption] = useState({});
    const [editData, setEditData] = useState({});
    const [showApprovePopup, setShowApprovePopup] = useState(false);
    const [approval, setApproval] = useState({
        status: '',
        from_date: null,
        to_date: null,
        selectedRadio: ""
    });
    const navigate = useNavigate();
    const [headerChecked, setHeaderChecked] = useState(false)
    const columnDefs = [
        {
            field: "checkbox",
            headerName: "",
            headerComponent: () => {
                return (
                    <div className="w100">
                        <input type="checkbox" onChange={(e) => { handleSelectAll(e) }} checked={headerChecked} />
                    </div>
                )
            },
            width: 40,
            hide: filterValues?.status?.request_status_key !== 'is_pending' || getValuePermission("helpdesk_action_col"),
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellRenderer: (params) => {
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                return (
                    <div>
                        {
                            (params?.data?.approver_user_code === dropDownOption?.userCode && params.data.request_status_id === pendingId) && <input type="checkbox" checked={params.data.is_checked} onChange={(e) => handleSelectAll(e, params)} />
                        }

                    </div>

                )
            }
        },
        {
            field: "edit",
            headerName: "Edit",
            width: 50,
            cellStyle: { textAlign: "center" },
            headerClass: "ag-text-center",
            hide: filterValues?.status?.request_status_id !== _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id,
            cellRenderer: (params) => {
                return (
                    <div style={{ cursor: "pointer" }}><FontAwesomeIcon icon="fa-solid fa-pen-to-square" onClick={() => { setShowRequestPopup(true); setEditData(params) }} /></div>
                )
            }
        },
        {
            field: "request_status_name",
            headerName: "Status",
            width: 50,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const approveId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_approved" })?.request_status_id;
                const rejectedId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_rejected" })?.request_status_id;
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                const grantId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_grant" })?.request_status_id;
                const partialId = -1;
                return (
                    <div>
                        {params.data.request_status_id === approveId && <FontAwesomeIcon icon="fa-solid fa-circle-check" style={{ color: "green" }} />}
                        {params.data.request_status_id === rejectedId && <FontAwesomeIcon icon="fa-solid fa-circle-xmark" style={{ color: "red" }} />}
                        {params.data.request_status_id === pendingId && <FontAwesomeIcon icon="fa-solid fa-clock" style={{ color: "#d4d404" }} />}
                        {params.data.request_status_id === partialId && <FontAwesomeIcon icon="fa-solid fa-thumbs-up" style={{ color: "green" }} />}
                        {params.data.request_status_id === grantId && <FontAwesomeIcon icon="fa-solid fa-check-double" style={{ color: "green" }} />}
                    </div>
                )
            }
        },
        {
            field: "request_status_name",
            headerName: "Action",
            width: 150,
            cellStyle: { textAlign: "center" },
            hide: filterValues?.status?.request_status_key !== 'is_pending' || getValuePermission("helpdesk_action_col"),
            cellRenderer: (params) => {
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                return (
                    <div>
                        {
                            (params?.data?.approver_user_code === dropDownOption?.userCode && params.data.request_status_id === pendingId) &&
                            <div className="d-flex gap-2 align-items-baseline justify-content-center ">
                                <label>
                                    <input
                                        type="radio"
                                        value="is_approved"
                                        onChange={(e) => { setShowApprovePopup(true); setApproval((prevState) => ({ ...prevState, data: params?.data?.jenkins_request_id, status: e.target.value, selectedRadio: "" })) }
                                        }
                                    />
                                    Approve
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="is_rejected"
                                        onChange={(e) => { handleRequest(e.target.value, params?.data?.jenkins_request_id, "reject") }
                                        }
                                    />
                                    Reject
                                </label>
                            </div>
                        }
                    </div>
                )
            }
        },
        { headerName: "Project Name", field: "project_name", width: 140, headerClass: "help-desk-grid-header" },
        {
            headerName: "Env Name", field: "environment_name", width: 80, cellStyle: { textAlign: "center" }, headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                return (
                    <div>
                        {params.data.environment_name !== undefined &&
                            <div>{params.data?.environment_name?.split(",")?.join(", ")}</div>
                        }
                    </div>
                )
            }
        },
        { headerName: "Jenkins Type", field: "jenkins_type_name", cellStyle: { textAlign: "center" }, width: 120, headerClass: "help-desk-grid-header" },
        { headerName: "Sub Type", field: "sub_type_name", cellStyle: { textAlign: "center" }, width: 120, headerClass: "help-desk-grid-header" },
        { headerName: "Job Name", field: "job_name", cellStyle: { textAlign: "center" }, width: 140, headerClass: "help-desk-grid-header" },
        { headerName: "Request By", field: "requested_user_name", width: 120, headerClass: "help-desk-grid-header" },
        { headerName: "Request To", field: "approver_user_name", width: 120, headerClass: "help-desk-grid-header" },
        {
            headerName: "Remark", field: "reason", width: 200, headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                return (
                    <div>
                        {
                            params?.data?.reason && <p title={params?.data?.reason}>{params?.data?.reason}</p>
                        }
                    </div>
                );
            },
        },
        {
            headerName: "Apply Date", field: "apply_datetime", width: 130, cellStyle: { textAlign: "center" }, headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.apply_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
        {
            headerName: "Approve Date",
            field: "approve_datetime",
            width: 130,
            hide: filterValues?.status?.request_status_id === _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id,
            cellStyle: { textAlign: "center" },
            headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.approve_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
        {
            headerName: "Expiry Date",
            field: "expiry_datetime",
            width: 130,
            hide: filterValues?.status?.request_status_id === _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id,
            cellStyle: { textAlign: "center" },
            headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.expiry_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },

    ];

    useEffect(() => {
        callautopopulate("request_status", "all_users", "projects", "user_info", "vpn_type").then((res) => {
            setDropDownOption({
                statusOptions: res?.request_status,
                users: _.sortBy(res?.all_users, "user_display_name"),
                projects: res?.projects?.sort((a, b) => a.project_name.localeCompare(b.project_name)),
                userCode: res?.user_info?.[0]?.user_code,
                vpnType: res?.vpn_type,
                apiCall: true

            })
            setFilterValues((prev) => ({ ...prev, status: res?.request_status?.[0] }));
        }).catch((error) => {
            console.error("error", error)
        })

    }, [])

    useEffect(() => {
        (dropDownOption?.apiCall && !fromReport) && getRequestedData();
    }, [dropDownOption?.apiCall])

    useEffect(() => {
        setDropDownOption((prev) => {
            const updatedOptions = { ...prev };
            if (!filterValues?.projects?.project_id) {
                updatedOptions.envOption = [];
                updatedOptions.jenkinsTypeOption = [];
                updatedOptions.jenkinsSubTypeOption = [];
                updatedOptions.jenkinsJobTypeOption = [];
            }
            if (!filterValues?.environment) {
                updatedOptions.jenkinsTypeOption = [];
                updatedOptions.jenkinsSubTypeOption = [];
                updatedOptions.jenkinsJobTypeOption = [];
            }
            if (!filterValues?.jenkinstype) {
                updatedOptions.jenkinsSubTypeOption = [];
                updatedOptions.jenkinsJobTypeOption = [];
            }
            return updatedOptions;
        });
    }, [filterValues?.projects?.project_id, filterValues?.environment, filterValues?.jenkinstype]);

    const handleSelectAll = (e, rowdata) => {
        const data = [...rowData];
        if (rowdata) {
            data[rowdata.node.rowIndex]["is_checked"] = e?.target?.checked;
            setRowData(data);
        } else {
            data.forEach((item) => {
                if (item.approver_user_code === dropDownOption?.userCode) {
                    item.is_checked = e?.target?.checked;;
                }
            });
            setHeaderChecked(!headerChecked)
            setRowData(data);
        }

    }

    const handleStatusChange = (e) => {
        const data = _.findWhere(dropDownOption?.statusOptions, {
            request_status_id: parseInt(e.target.value),
        });
        setFilterValues((prev) => ({ ...prev, status: data }));
        getRequestedData(null, parseInt(e.target.value))
    };

    useEffect(() => {
        filterValues?.apiCall && getRequestedData()
    }, [filterValues?.apiCall])

    useEffect(() => {
        if (filterValues?.apiCall && filterValues?.projects?.project_id) {
            GetJenkinsEnvType();
        }
    }, [filterValues?.apiCall, filterValues?.projects?.project_id]);


    const GetJenkinsEnvType = async () => {

        const payload = {
            "project_id": filterValues?.projects?.project_id || 0,
            "environment_id": _.pluck(filterValues?.environment, "environment_id").toString() || '',
            "jenkins_type_id": _.pluck(filterValues?.jenkinstype, "jenkins_type_id").toString() || '',
            "jenkins_sub_type_id": _.pluck(filterValues?.jenkinsSubtype, "jenkins_sub_type_id").toString() || '',
        }
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETJENKINSENVTYPE"), payload);
            if (res?.status === 200) {
                setDropDownOption((prev) => ({
                    ...prev,
                    envOption: res?.body?.data?.project_env_list,
                    jenkinsTypeOption: res?.body?.data?.jenkins_env_list,
                    jenkinsSubTypeOption: res?.body?.data?.jenkins_subtype_env_list,
                    jenkinsJobTypeOption: res?.body?.data?.jenkins_job_type,
                }))
            }
        } catch (error) {
            showError('Error', error?.response?.data?.errorMessage);
            console.error("Error:", error);
        }
    }

    const getRequestedData = async (type, status, filters) => {
        try {
            setRowData([]);
            setLoader(true);
            const payload = {
                "project_ids": type === "clear" ? "" : (_.isArray(filters?.projects || filterValues?.projects) ? _.map(filters?.projects || filterValues?.projects, p => p.project_id).toString() : (filters?.projects || filterValues?.projects)?.project_id || ""),
                "request_status_id": status ? status : filterValues?.status?.request_status_id,
                "from_date": filters?.from_date ? dateConvert(filters?.from_date, "iso-string") : ((filterValues?.hoveredRange && filterValues?.hoveredRange[0] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[0]) : '') || "",
                "to_date": filters?.to_date ? dateConvert(filters?.to_date, "iso-string") : ((filterValues?.hoveredRange && filterValues?.hoveredRange[1] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[1]) : '') || "",
                "users": _.pluck(filterValues?.all_users, "user_code").toString(),
                "environment_ids": type === "clear" ? "" : _.pluck(filterValues?.environment, "environment_id").toString(),
                "jenkins_type_ids": type === "clear" ? "" : _.pluck(filterValues?.jenkinstype, "jenkins_type_id").toString(),
                "jenkins_sub_type_ids": type === "clear" ? "" : _.pluck(filterValues?.jenkinsSubtype, "jenkins_sub_type_id").toString(),
                "job_ids": type === "clear" ? "" : _.pluck(filterValues?.jenkinsJob, "job_id").toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("GETJENKINSREQUESTDETAIL"), payload);
            if (res?.StatusCode === 202 || res?.status === 202) {
                showError("Error", res.body.errorMessage);
                setLoader(false);
            } else if (res.body.data) {
                setLoader(false);
                setRowData(_.sortBy(_.uniq(res.body.data.jenkins_detail, (item) => item.jenkins_request_id), "requested_user_name"));
            }
            setFilterValues((prev) => ({ ...prev, isApiCall: false, apiCall: false }))
        } catch (error) {
            setLoader(false);
            console.error("Error", error);
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader(false);
        }
    }

    // handle the vpn approve & reject request 
    const handleRequest = async (status, id) => {
        try {
            if ((status === "is_rejected" && (!id || id?.length <= 0)) || (approval.status === "is_approved" && (!approval?.data || approval?.data?.length <= 0))) {
                showInfo("Info", "Please select a request to reject");
                return;
            }
            const requestStatus = _.findWhere(dropDownOption?.statusOptions, { request_status_key: status || approval.status })
            const payload = {
                "jenkins_request_ids": id ? id?.toString() : approval?.data?.toString(),
                "request_status_id": requestStatus.request_status_id,
                "expiry_datetime": approval?.expiryDate || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTJENKINSREQUESTAPPROVE"), payload)
            if (res.body.data) {
                showSuccess('Success', res.body.message)
                setShowApprovePopup(false)
                getRequestedData()
                setApproval((prevState) => ({ ...prevState, status: '', to_date: null, from_date: null, expiryDate: null, selectedRadio: "" }))
            }
            else {
                showError("Error", res.body.errorMessage);
            }


        } catch (error) {
            console.error("Error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    return useMemo(() => ({
        loader, tagRef, columnDefs, filterValues, setFilterValues, getRequestedData, rowData, showRequestPopup, setShowRequestPopup, dropDownOption, handleStatusChange, showApprovePopup, setShowApprovePopup, navigate, handleRequest, editData, setEditData, approval, setApproval, GetJenkinsEnvType, showInfo
    }), [loader, tagRef, columnDefs, filterValues, setFilterValues, getRequestedData, rowData, showRequestPopup, setShowRequestPopup, dropDownOption, handleStatusChange, showApprovePopup, setShowApprovePopup, navigate, handleRequest, editData, setEditData, approval, setApproval, GetJenkinsEnvType, showInfo]);
}